import React, { useState, useEffect } from 'react'
import { wideFormInput } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import i18n from '@localization/i18n'
import MessageModal from '@components/Modals/MessageModal'
import {
    PageHeader,
    PageSubTitle,
    SubmitBtn,
    SubmitBtnContainer,
    FormWrapper,
    FormRow,
    ErrorText,
    WrapperDiv,
} from '@appearance/styled'
import api from '../services/api'

export default () => {
    const [email, setEmail] = useState('')
    const [emailValid, setEmailValid] = useState(null)
    const [error, setError] = useState(null)
    const [showDoneModal, setShowDoneModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const errorText = i18n.t('forgot_password.email_not_found')
    const formValid = () => emailValid

    useEffect(() => {
        setError(null)
        setErrorPerField(emailValid, i18n.t('forgot_password.unvalid_email'))
    }, [emailValid])

    const setErrorPerField = (field, error) => {
        if (field === false) {
            setError(error)
        }
    }

    const doSubmit = () => {
        if (formValid()) {
            api.forgotPassword(email).subscribe(
                (res) => {
                    setShowDoneModal(true)
                    // console.log('resetPassword res', res)
                },
                (error) => {
                    setShowErrorModal(true)
                    console.log('resetPassword error123', error)
                }
            )
        }
    }

    return (
        <WrapperDiv>
            <PageHeader>{i18n.t('forgot_password.title')}</PageHeader>
            <PageSubTitle>{i18n.t('forgot_password.description')}</PageSubTitle>
            <FormWrapper>
                <FormRow>
                    <ErrorText>{error}</ErrorText>
                </FormRow>
                <FormRow justifyContent={'center'} alignItems={'center'}>
                    <TextInput
                        type="email"
                        label={i18n.t('forgot_password.email')}
                        text={email}
                        onChangeText={setEmail}
                        onError={(err) => setEmailValid(!err)}
                        required={true}
                        width={wideFormInput}
                        hideRequiredSign={true}
                    />
                </FormRow>
                <SubmitBtnContainer>
                    <SubmitBtn onClick={doSubmit} disabled={!formValid()}>
                        {i18n.t('forgot_password.send')}
                    </SubmitBtn>
                </SubmitBtnContainer>
            </FormWrapper>
            <MessageModal
                isOpen={showDoneModal}
                title={i18n.t('forgot_password.email_sent')}
                mainText={i18n.t('forgot_password.check_email')}
                onClose={() => setShowDoneModal(false)}
            />
            <MessageModal
                isOpen={showErrorModal}
                title={i18n.t('forgot_password.error')}
                mainText={errorText}
                onClose={() => setShowErrorModal(false)}
                error
            />
        </WrapperDiv>
    )
}
